import { useTranslation } from 'react-i18next';

import classes from './PanelHeader.module.scss';

export default function PanelHeader({
  userShoewn,
  userCliclHandler,
  setNotificationsHandler,
}) {
  const { t } = useTranslation('panel');
  return (
    <div className={classes.header}>
      <span
        className={`${classes['header-item']} ${
          !userShoewn ? classes['notifications-active'] : ''
        }`}
        onClick={setNotificationsHandler}
      >
        {t('Notifications')}
      </span>
      <span
        onClick={userCliclHandler}
        className={`${classes['header-item']}  ${
          userShoewn ? classes['user-active'] : ''
        }`}
      >
        {t('Users')}
      </span>
    </div>
  );
}
